import { createContext, useContext } from "react";

/** The finance documents the guided-steps dialog can create. */
export type DocumentCreateKind = "estimate" | "invoice" | "purchase_order";

/** Where the launch came from, for analytics. */
export type DocumentCreateSource = "dashboard-quick-action" | "floating-action-button";

export interface DocumentCreateLauncher {
  /** Opens the guided-steps dialog for `kind` over the current route. */
  open: (kind: DocumentCreateKind, source: DocumentCreateSource) => void;
}

/**
 * Feature-free seam between shared chrome (the floating quick-actions button)
 * and the dialog that hosts the finance create workflows. The provider lives
 * in `features/document-create`; callers without one fall back to navigating.
 */
export const DocumentCreateLauncherContext = createContext<DocumentCreateLauncher | null>(null);

export function useDocumentCreateLauncher(): DocumentCreateLauncher | null {
  return useContext(DocumentCreateLauncherContext);
}
